module.exports = __webpack_public_path__ + "img/MESTNA OBCINA PTUJ.223430f3.png";